
import { useEffect } from "react";
import { getLastIdSessionInCourse } from "../helpers/array";

// useUpdateSelectedChat: Custom hook que actualiza los datos del chat seleccionado cuando se selecciona un chat desde el inbox.

const useUpdateSelectedChat = (sessionsChatSelected, chatData, setSessions, setSessionSelected, handleClosePreview) => {

    useEffect(() => {
        const onChangeChat = () => {
            setSessionSelected({}); // Borrar el id de la sesión seleccionada y retornarlo vacío
            setSessions(sessionsChatSelected);
            console.log("este es el chat seleccionado", sessionsChatSelected);
            let lastIdSessionInCourse = getLastIdSessionInCourse(sessionsChatSelected);
            if (lastIdSessionInCourse) {
                console.log("se encontro la ultima sesion en curso", lastIdSessionInCourse);
                setSessionSelected(lastIdSessionInCourse);
            }
            handleClosePreview([]); //funcion de callback para cerrar la ventana de archivos multimedia en caso de que se encuentre abierta.
        };
        onChangeChat();
    }, [sessionsChatSelected, chatData ]);


};

export default useUpdateSelectedChat;
